// extracted by mini-css-extract-plugin
export default {"sudokuChooser":"component_sudokuChooser__HYZAv","content":"component_content__p-d+o","movingBanner":"component_movingBanner__YH00D"};